<template>
  <b-modal
    ref="trade-in-qc-modal"
    id="trade-in-qc-modal"
    size="lg"
    title="Kiểm định máy thu cũ"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <p class="mb-3">
      Chọn xử lý cho máy. Máy đưa vào tồn kho thu cũ sẽ nằm tại cửa hàng, không
      bán được; muốn chuyển đi thì tạo phiếu chuyển kho tay.
    </p>
    <table class="table table-bordered table-vertical-center">
      <thead>
        <tr>
          <th>Sản phẩm</th>
          <th>IMEI</th>
          <th style="width: 40%">Xử lý</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in items" :key="row.imei">
          <td>{{ row.productName }}</td>
          <td>{{ row.imei }}</td>
          <td>
            <b-form-radio-group
              v-model="decisions[row.imei]"
              :options="decisionOptions"
              :disabled="loading"
              stacked
            />
          </td>
        </tr>
      </tbody>
    </table>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        :disabled="loading"
        @click="onCancel"
      >
        Hủy
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        :disabled="!canConfirm || loading"
        @click="onConfirm"
      >
        Xác nhận
      </b-button>
    </template>
  </b-modal>
</template>

<script>
// t103002: lựa chọn cho từng IMEI sau khi bấm Lưu phiếu nhập máy cũ
const DECISION = Object.freeze({
  APPROVE: 1, // Duyệt bán - vào tồn bán như cũ
  TRADE_IN_STOCK: 2, // Đưa vào tồn kho thu cũ - nằm tại cửa hàng, chuyển kho tay sau
});

export default {
  props: {
    // [{ imei, productName }]
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      decisionOptions: [
        { text: 'Duyệt bán', value: DECISION.APPROVE },
        { text: 'Đưa vào tồn kho thu cũ', value: DECISION.TRADE_IN_STOCK },
      ],
      decisions: {},
    };
  },
  computed: {
    rejectedImeis() {
      return this.items
        .map((row) => row.imei)
        .filter((imei) => this.decisions[imei] === DECISION.TRADE_IN_STOCK);
    },
    canConfirm() {
      return this.items.every((row) => !!this.decisions[row.imei]);
    },
  },
  methods: {
    show() {
      // Mỗi lần mở phải chọn lại từ đầu - không chọn sẵn để nhân viên buộc phải quyết định
      this.decisions = this.items.reduce((result, row) => {
        result[row.imei] = null;
        return result;
      }, {});
      this.$refs['trade-in-qc-modal'].show();
    },
    hide() {
      this.$refs['trade-in-qc-modal'].hide();
    },
    onCancel() {
      this.hide();
      this.$emit('cancel');
    },
    onConfirm() {
      if (!this.canConfirm) return;
      this.$emit('confirm', { rejectedImeis: this.rejectedImeis });
    },
  },
};
</script>
